import styled from 'styled-components';

export default {
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
        z-index: 101;
        overflow-y: auto;
        @media (min-width: 700px) {
            overflow-y: hidden;
        }
    `,
    ModalContent: styled.div.attrs({ className: 'modal-content' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        position: relative;
        border: 1px solid #5B6164;
        top: 340px;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: auto;
        max-height: ${props => props.error && props.error === true ? '392px' : '666px'};
        padding: 48px 24px;
        width: 81%;
        z-index: 1000;
        background: #FFFFFF;
        @media (min-width: 700px) {
            width: 610px;
            height: auto;
            max-height: ${props => props.error && props.error === true ? '425px' : '641px'};
        }
        @media (min-width: 1000px) {
            padding: 25px;
            width: 930px;
        }
        @media (max-width: 700px) {
            top: ${props => !props.task ? props.error && props.error === true ? '260px' : '320px' : '300px'};
        }
        @media (max-width: 320px) {
            width: 79%;
        } 
    `,
    ModalTitle: styled.h3.attrs({ className: 'modal-title' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 18px;
        line-height: 40px;
        letter-spacing: 1.5px;
        font-weight: 400;
        text-transform: uppercase;
        display: block;
        text-align: center;
        padding: 0;
        margin: 0;
        width: 90%;
        @media (min-width: 1000px) {
            font-size: 40px;
            line-height: 140%;
            text-align: center;
            letter-spacing: 1.5px;
            text-transform: uppercase;
        }
    `,
    ModalTextContainer: styled.div.attrs({ className: 'modal-text-container' })`
        max-width: 839px;
        margin: 38px 17px 35px;
        min-height: 82px;
        max-height: 270px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        position: relative;
        &:after {
                position: fixed;
                display: ${props => props.content.length > 1 ? 'block' : 'none'};
                content: ' ';
                height: 40px;
                bottom: 127px;
                left: 0;
                width: 100%;
                background: ${props => props.error && props.error === true ? 'rgba(0, 0, 0, 0.0)' : 'linear-gradient(0deg,#FFFFFF 0%,rgba(255,255,255,0) 103.75%)'};
        }
    `,
    ModalText: styled.div.attrs({ className: 'modal-text' })`
        width: 100%;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 20px;
        color: #202020;
    `,
    ModalList: styled.ul.attrs({ className: 'modal-list' })` 
        text-align: ${props => props.error ? 'center' : 'left'};
        list-style: none;
        margin: 0 5px 0 0;
        padding-left: 0;
        & li {
            margin-bottom: 10px;
            font-size: 16px;
            line-height: 24px;
            font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
            font-weight: 400;
            color: #5B6164;
            
            ${({ error }) => error && `
                font-size: 18px;
                line-height: 32px;      
                letter-spacing: 0.5px;
                color: #1A1A1A;      
            `}
        }
    `,
    ModalBody: styled.div.attrs({ className: 'modal-body' })`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        @media (min-width: 1000px) {
            margin-top: 54px;
        }
    `,
    ModalClose: styled.div.attrs({ className: 'modal-close' })`
        width: auto;
        height: auto;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        top: 11px;
        right: 9px;
        @media (min-width: 1000px) {
            top: 37px;
            right: 34px;
        }
    `,
    InputError: styled.span.attrs({ className: 'input-error' })`
        position: absolute;
        bottom: -20px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #E50000;
    `,
    ButtonNext: styled.div.attrs({ className: 'button-next' })`
        width: 184px;
        height: 48px;
        padding: 0 25px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        letter-spacing: 1px;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 20px;
        color: #1A1A1A;
        background: #FFFFFF;
        border: 1px solid #B9C0C2;
        box-sizing: border-box;
        transition: 0.2s ease-in-out;
        text-transform: uppercase;
        outline: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        position: relative;
        
        &:after{
          content: '';
          display: block;
          position: absolute;
          background: #1A1A1A;
          height: 1px;
          top: 50%;
          width: 25px;
          right: 25px;
          transition: 0.2s ease-in-out;
        }
        &:active, &:hover {
            background: #1A1A1A;
            color: #FFFFFF;
            &:after{
              background: #FFFFFF;  
            }
        }
        &.opacity {
            opacity: 0.3;
        }
        @media(min-width: 700px) {
            margin-bottom: 15px;
        }
    `,
};
